import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from '../api/api.service';

/** Number of unhandled website requests, shown as a badge in the sidebar. */
@Injectable({
  providedIn: 'root',
})
export class WebRequestsCountService implements OnDestroy {
  readonly count$ = new BehaviorSubject<number>(0);
  private timer?: ReturnType<typeof setInterval>;

  constructor(private api: ApiService) {}

  start(): void {
    if (this.timer) return;
    void this.refresh();
    this.timer = setInterval(() => void this.refresh(), 60000);
  }

  async refresh(): Promise<void> {
    try {
      const result = await this.api.request('/web-requests/count', {});
      this.count$.next(Number(result?.new || 0));
    } catch {
      // The badge is optional: keep the last value if the request fails.
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }
}
